import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { getSentReviewInvitations } from '@/lib/api/reviews/sent-invitations';

export function useSentInvitationsQuery() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['sent-invitations', user?.id],
    queryFn: () => getSentReviewInvitations(user!.id),
    enabled: !!user?.id,
  });
}
